















import Vue from "vue";
import EntityFormField from "@/components/common/EntityFormField.vue";
import FormField from "@/meta/FormField";
import { cloneDeep } from "lodash";

export default Vue.extend({
  name: "EntityForm",
  components: { EntityFormField },
  props: {
    fields: {
      type: Array as () => FormField[],
      required: true,
    },
    item: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    title: {
      type: String,
      required: false,
      default: "Entity Form",
    },
  },
  data: () => {
    return {
      itemLocal: {} as any,
    };
  },
  watch: {
    item: {
      handler(newValue: any) {
        console.log(newValue);
        this.itemLocal = cloneDeep(newValue);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    submitForm() {
      this.$emit("submit", this.itemLocal);
    },
    updateValue(field: string, value: any) {
      this.$set(this.itemLocal, field, value);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
});
